(() => {
  "use strict";

  if (window.__wyrdFilterSheetBound) {
    return;
  }

  window.__wyrdFilterSheetBound = true;

  const root = document.documentElement;

  function setupFabVisibility() {
    document
      .querySelectorAll("[data-wyrd-collection], [data-wyrd-search]")
      .forEach((collection) => {
      const fab = collection.querySelector(".wyrd-filter-fab");

      if (!(fab instanceof HTMLElement)) {
        return;
      }

      if (typeof window.IntersectionObserver !== "function") {
        fab.classList.add("is-visible");
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            fab.classList.toggle("is-visible", entry.isIntersecting);
          }
        },
        {
          rootMargin: "0px 0px -10% 0px",
          threshold: 0,
        }
      );

      observer.observe(collection);
      });
  }

  function openSheet(dialog, trigger) {
    dialog.__wyrdTrigger = trigger;

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    root.classList.add("wyrd-filter-sheet-open");

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) {
        dialog.showModal();
      }
    } else {
      dialog.setAttribute("open", "");
    }

    const closeButton = dialog.querySelector("[data-wyrd-filter-close]");

    if (closeButton instanceof HTMLElement) {
      window.requestAnimationFrame(() => closeButton.focus());
    }
  }

  function finishClose(dialog) {
    root.classList.remove("wyrd-filter-sheet-open");

    const trigger = dialog.__wyrdTrigger;

    if (trigger instanceof HTMLElement) {
      trigger.setAttribute("aria-expanded", "false");
      trigger.focus({ preventScroll: true });
    }

    dialog.__wyrdTrigger = null;
  }

  function closeSheet(dialog) {
    if (typeof dialog.close === "function" && dialog.open) {
      dialog.close();
      return;
    }

    dialog.removeAttribute("open");
    finishClose(dialog);
  }

  document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const openButton = target.closest("[data-wyrd-filter-open]");

    if (openButton instanceof HTMLElement) {
      const dialogId = openButton.dataset.wyrdFilterOpen;
      const dialog = dialogId ? document.getElementById(dialogId) : null;

      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        openSheet(dialog, openButton);
      }

      return;
    }

    const closeButton = target.closest("[data-wyrd-filter-close]");

    if (closeButton) {
      const dialog = closeButton.closest("dialog");

      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        closeSheet(dialog);
      }

      return;
    }

    if (
      target instanceof HTMLDialogElement &&
      target.classList.contains("wyrd-filter-sheet") &&
      target.open
    ) {
      closeSheet(target);
    }
  });

  document.addEventListener(
    "close",
    (event) => {
      if (
        event.target instanceof HTMLDialogElement &&
        event.target.classList.contains("wyrd-filter-sheet")
      ) {
        finishClose(event.target);
      }
    },
    true
  );

  document.addEventListener(
    "cancel",
    (event) => {
      if (
        event.target instanceof HTMLDialogElement &&
        event.target.classList.contains("wyrd-filter-sheet")
      ) {
        root.classList.remove("wyrd-filter-sheet-open");
      }
    },
    true
  );

  setupFabVisibility();
})();
